/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react"
import { useLocation } from "react-router"
import { NavLink } from "react-router-dom"
import SVG from "react-inlinesvg"
import { Brand } from "../../brand/Brand";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers"
import { useDispatch, useSelector, shallowEqual } from "react-redux";

export function HeaderMenu({ layoutProps }) {
  const location = useLocation()
  const getMenuItemActive = (url) => {
    return checkIsActive(location, url) ? "menu-item-active" : ""
  }
  const { itemscount } = useSelector((state) => ({
    itemscount:
      state.products && state.products.cartitemcount
  }))

  const menuList = [
    {
      key: "all-inventory",
      icon: "/media/svg/icons/Layout/Layout-grid.svg",
      name: "All Inventory",
      width: "113px"
    },
    {
      key: "my-inventory",
      icon: "/media/svg/icons/Layout/Layout-top-panel-4.svg",
      name: "My Inventory",
      width: "119px"
    },
    // {
    //   key: "pricing-rule",
    //   icon: "/media/svg/icons/Shopping/Cart2.svg",
    //   name: "Pricing Rule",
    //   width: "102px"
    // },
    {
      key: "my-orders",
      icon: "/media/svg/icons/Shopping/Cart2.svg",
      name: "Orders",
      width: "102px"
    },

    {
      key: "marketing-material",
      icon: "/media/svg/icons/Files/Selected-file.svg",
      name: "Marketing Material",
      width: "159px"
    },
    {
      key: "my-account",
      icon: "/media/svg/icons/General/User.svg",
      name: "My Account",
      width: "113px"
    },
    {
      key: "help",
      icon: "/media/svg/icons/Code/Question-circle.svg",
      name: "Help",
      width: "55px"
    },
    {
      key: "return",
      icon: "/media/svg/icons/Code/Time-schedule.svg",
      name: "Returns",
      width: "75px"
    },
    {
      key: "cart",
      icon: "bi bi-cart",
      name: "Cart",
      width: "50px"
    },
    {
      key: "trunkey",
      icon: "/media/svg/icons/Design/Layers.svg",
      name: "$99 TURNKEY WEBSITE",
      width: "178px"
    },
    {
      key: "upgrade-save",
      icon: "/media/svg/icons/Tools/Tools.svg",
      name: "UPGRADE & SAVE",
      width: "145px"
    },

  ]

  // check shop exist or not
  const path = window.location.href.replace(/^.+\?/i, "")
  const searchParams = new URLSearchParams(path)
  const shop = searchParams.get("shop")
  const host = searchParams.get("host")

  return (
    <div
      id="kt_header_menu"
      className={`header-menu header-menu-mobile ${layoutProps.ktMenuClasses}`}
      {...layoutProps.headerMenuAttributes}
    >
      <Brand />
      <div class="right-header d-flex gap-3">
        {/*begin::Header Nav*/}
        <div className="header-menu-links">
          <ul
            className={`menu-nav gap-4 ${layoutProps.ulClasses}`}
          >
            {/* Render main menu items except divider, cart, trunkey, upgrade-save */}
            {menuList &&
              menuList.filter(item => !["cart", "trunkey", "upgrade-save"].includes(item.key)).map((item, index) => (
                <li
                  className={`menu-item menu-item-rel ${getMenuItemActive(item.key)}`}
                  key={item.key}
                >
                  <NavLink
                    className="menu-link"
                    to={`/${item.key}?shop=${shop}&host=${host}`}
                    onClick={(e) => {
                      e.preventDefault()
                      window.location.href = `/${item.key}?shop=${shop}&host=${host}`
                    }}
                  >
                    {item.name}
                    {layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
                  </NavLink>
                </li>
              ))}
          </ul>
        </div>

        {/* Divider and special menu items in separate ul */}
        <div className="header-menu-buttons">
          <ul className="menu-nav special-menu-nav gap-4" style={{ display: "inline-flex", marginLeft: 10 }}>
            {/* Divider before cart */}
            <li className="menu-item menu-item-rel false verticle-line"></li>

            {/* Cart menu item */}
            {menuList.find(item => item.key === "cart") && (
              <li className={`menu-item menu-item-rel ${getMenuItemActive("cart")}`} key="cart">
                <NavLink
                  className="cart-link menu-link position-relative d-flex align-items-center"
                  to={`/cart?shop=${shop}&host=${host}`}
                  style={{ textDecoration: 'none' }}
                >
                  <i className="fa-solid fa-shopping-cart text-lg"></i>
                  <span className="countpill">{itemscount || 0}</span>
                  {layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
                </NavLink>
              </li>
            )}

            {/* Trunkey menu item */}
            {menuList.find(item => item.key === "trunkey") && (
              <li className={`menu-item menu-item-rel promo_page ${getMenuItemActive("trunkey")}`} key="trunkey">
                <a
                  className="menu-link active gray-btn"
                  href={`/trunkey?shop=${shop}&host=${host}`}
                  aria-current="page"
                >
                  <i className="fa-brands fa-shopify text-white w-4 text-center"></i>
                  {/* Get Preloaded Website - $99 */}
                  Get Turnkey Website - $99
                </a>
              </li>
            )}

            {/* Upgrade & Save menu item */}
            {menuList.find(item => item.key === "upgrade-save") && (
              <li className={`menu-item menu-item-rel promo_page ${getMenuItemActive("upgrade-save")}`} key="upgrade-save">
                <a
                  className="menu-link red-btn"
                  href={`/upgrade-save?shop=${shop}&host=${host}`}
                >
                  <i className="fa-solid fa-arrow-up-wide-short text-white w-4 text-center"></i>
                  Upgrade & Save
                </a>
              </li>
            )}
          </ul>
        </div>
        {/*end::Header Nav*/}
      </div>
    </div>
  )
}
